export default __webpack_public_path__ + "static/char-s-53-ko-a946d0e49d34f9d8d487547dc7ba9801.png";